import { render } from "./FiltersRealEstateInAgency.vue?vue&type=template&id=471d09c4&ts=true"
import script from "./FiltersRealEstateInAgency.vue?vue&type=script&lang=ts"
export * from "./FiltersRealEstateInAgency.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_typescript@5.3.3__webpack@5.91.0_webpack-cli@5.1.4_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__